type BreadcrumbItem = {
  name?: string | null;
  path: string;
};

type ClientBreadcrumbSchemaProps = {
  items: BreadcrumbItem[];
  baseUrl: string;
};

const ClientBreadcrumbSchema = ({
  items,
  baseUrl,
}: ClientBreadcrumbSchemaProps) => {
  if (!items.length) {
    return null;
  }

  const breadcrumbItems = [
    // {
    //   name: 'Home',
    //   path: '/',
    // },
    ...items,
  ];

    const getAbsoluteUrl = (path: string, baseUrl: string) => {
        if (/^https?:\/\//i.test(path)) {
            return path;
        }

        return `${baseUrl}${path.startsWith('/') ? path : `/${path}`}`;
    };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: getAbsoluteUrl(item.path, baseUrl),
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(breadcrumbSchema),
      }}
    />
  );
};

export default ClientBreadcrumbSchema;